import React, { useState } from "react";
import useStyles from "./styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DialogRaw from "./DialogRaw";
import { DialogOption } from "./DialogRawProps";

interface Props {
    displayLabel: string;
    options: DialogOption[];

    onClose: (key?: number) => void;
}

const ConfirmationDialog = ({ displayLabel, options, onClose } : Props) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("");

    const handleClickListItem = () => {
        setOpen(true);
    };

    const handleClose = (newValue?: string, key?: number) => {
        setOpen(false);

        if (newValue) {
            setValue(newValue)
            onClose(key);
        }
    };

    React.useEffect(() => {
          setValue("");
      }, []);

    return (
        <div className={classes.root}>
            <List component="div" role="list">
                <ListItem
                    button
                    aria-haspopup="true"
                    aria-controls="option-menu"
                    aria-label={displayLabel}
                    onClick={handleClickListItem}
                    role="listitem"
                >
                    <ListItemText primary={displayLabel} secondary={value} />
                </ListItem>
                <DialogRaw
                    classes={{
                        paper: classes.paper,
                    }}
                    id="options"
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    value={value}
                    options={options}
                />
            </List>
        </div>
    );
};

export default ConfirmationDialog;